// extracted by mini-css-extract-plugin
export var button = "_dv-4";
export var hasDarkBackground = "_dv-7";
export var hasLightBackground = "_dv-6";
export var iconWrapper = "_dv-0";
export var large = "_dv-2";
export var medium = "_dv-1";
export var small = "_dv-5";
export var xsmall = "_dv-3";